/**
 * complementary-color-sync.js
 *
 * Sincroniza el color/acabado de los productos recomendados en el bloque
 * "Perfecto con" (complementary products) del producto principal.
 *
 * Cuando el cliente cambia el "Acabado" del producto principal (p. ej. de
 * "Cromado" a "Oro Cepillado"), cada tarjeta complementaria se actualiza
 * para mostrar/enlazar la variante de ESE MISMO acabado, si existe.
 *
 * Piloto: Serie Toscana (Columna de Ducha Monomando / Termostática ->
 * Ducha Higiénica WC, Grifo Caño Alto, Grifo Caño Bajo).
 *
 * Requiere que snippets/product-complementary.liquid embeba, por cada
 * producto recomendado, un <script type="application/json"
 * class="complementary-color-map"> con el mapa color -> variante.
 */
(function () {
  'use strict';

  var OPTION_NAME = 'Acabado';
  var CARD_SELECTOR = '.complementary-card';
  var MAP_SELECTOR = '.complementary-color-map';
  var CHOOSE_BTN_SELECTOR = '.product-card__atc[aria-haspopup="dialog"]';

  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function isAcabadoInput(el) {
    if (!el || !el.name) return false;
    // El propio tema deja a veces espacios/saltos de línea alrededor del
    // atributo name (viene de un {% capture %} de Liquid), así que
    // normalizamos antes de comparar en vez de anclar con $.
    var name = el.name.trim();
    if (new RegExp('^' + OPTION_NAME + '-\\d+$').test(name)) return true;
    if (name === 'options[' + OPTION_NAME + ']') return true;
    return false;
  }

  function getCurrentAcabadoValue() {
    var checkedRadio = document.querySelector(
      'variant-selects input[name^="' + OPTION_NAME + '-"]:checked'
    );
    if (checkedRadio) return checkedRadio.value;

    var select = document.querySelector(
      'variant-selects select[name="options[' + OPTION_NAME + ']"]'
    );
    if (select && select.selectedOptions && select.selectedOptions[0]) {
      return select.selectedOptions[0].value;
    }

    return null;
  }

  function readColorMap(card) {
    var mapEl = card.querySelector(MAP_SELECTOR);
    if (!mapEl) return null;
    try {
      return JSON.parse(mapEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function applyColorToCard(card, color) {
    if (!color) return;

    var map = readColorMap(card);
    if (!map || !map.length) return;

    var target = normalize(color);
    var match = map.filter(function (v) {
      return normalize(v.color) === target;
    })[0];

    // Sin coincidencia de color para este producto: dejamos la tarjeta
    // con su comportamiento por defecto (no intentamos "adivinar").
    if (!match) {
      delete card.dataset.colorSyncedUrl;
      card.classList.remove('complementary-card--color-synced');
      return;
    }

    card.dataset.colorSyncedUrl = match.url;
    card.classList.add('complementary-card--color-synced');
    card.classList.toggle('complementary-card--unavailable', match.available === false);

    // Imagen principal de la tarjeta.
    var img = card.querySelector('.product-card__image--main img');
    if (img && match.image) {
      img.src = match.image;
      if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
    }

    // Enlaces de imagen y título -> variante del color seleccionado.
    var productBase = match.url.split('?')[0];
    card.querySelectorAll('a[href]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href) return;
      var base = href.split('?')[0];
      if (base === productBase) {
        a.setAttribute('href', match.url);
      }
    });
  }

  function applyColorToAllCards(root, color) {
    if (!root || !color) return;
    root.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
      applyColorToCard(card, color);
    });
  }

  // El botón "Elegir opciones" abre por defecto un quick-view (modal), que
  // no respeta el color seleccionado. Cuando tenemos una variante del
  // mismo color, llevamos directamente a esa variante en la ficha de
  // producto en lugar de abrir el modal.
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest(CARD_SELECTOR + ' ' + CHOOSE_BTN_SELECTOR);
      if (!btn) return;

      var card = btn.closest(CARD_SELECTOR);
      var url = card && card.dataset.colorSyncedUrl;
      if (!url) return;

      event.preventDefault();
      event.stopPropagation();
      window.location.href = url;
    },
    true
  );

  // 'recommendations:loaded' se dispara sin burbujeo (bubbles: false), así
  // que un listener normal en document nunca lo vería; con capture:true sí
  // lo detectamos, porque la fase de captura ocurre siempre.
  document.addEventListener(
    'recommendations:loaded',
    function (event) {
      var root = event.target;
      if (!root || !root.classList || !root.classList.contains('complementary-products')) return;
      applyColorToAllCards(root, getCurrentAcabadoValue());
    },
    true
  );

  function subscribeToVariantChanges() {
    if (!(window.FoxTheme && window.FoxTheme.pubsub)) return false;

    window.FoxTheme.pubsub.subscribe(
      window.FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
      function (evt) {
        var target = evt && evt.data && evt.data.target;
        if (!isAcabadoInput(target)) return;

        var color = target.value;
        document.querySelectorAll('product-recommendations.complementary-products').forEach(function (root) {
          applyColorToAllCards(root, color);
        });
      }
    );
    return true;
  }

  if (!subscribeToVariantChanges()) {
    document.addEventListener('DOMContentLoaded', subscribeToVariantChanges);
  }
})();